import TextField from "@/components/layouts/History/TextField";
import { useCompanies } from "@/pages/companies/hooks";

interface Props {
  value: string;
}

const CompanyName: React.FC<Props> = ({ value }) => {
  const {
    entities: [companyData]
  } = useCompanies([value]);
  if (!companyData) return null;
  return <TextField>{companyData.name}</TextField>;
};

export default CompanyName;
